"use strict";

const _ = require('lodash');
const health = require('./health');
const apiClient = require('./api-client');
const Controller = require('./controller');
const apiCall = apiClient.apiCall;

function APIControllerMixin(superclass) {
	return class extends superclass {
		constructor(options) {
			super(... arguments);
			this._wrapApiCall();
			_.bindAll(this, 'load', 'reload');
		}

		getApiCallOptions(options) {
			return Object.assign({}, this.options, options);
		}

		runApiCall(options) {
			return apiCall(options);
		}

		processResponse(response) {
			if (response) {
				this.options.data = response;
			}
			return response;
		}

		apiCall(options) {
			let self = this;
			return Promise.resolve()
				.then(function () {
					return self.getApiCallOptions(options);
				})
				.then(function (options) {
					return self.runApiCall(options);
				})
				.then(function (response) {
					return self.processResponse(response);
				});
		}

		_wrapApiCall() {
			let self = this;
			let apiCall = this.apiCall;
			this.apiCall = function wrappedApiCall(... args) {
				if (self._apiCallIsDeferred) {
					self._apiCallIsDeferred(new Error('API call has be cancelled'));
					delete self._apiCallIsDeferred;
				}
				return new Promise(function (resolve, reject) {
					self._apiCallIsDeferred = reject;
					self.onApiCallStart();
					apiCall.call(self, ... args)
						.then(
							function (result) {
								delete self._apiCallIsDeferred;
								self.onApiCallFinish();
								resolve(result);
							},
							function (err) {
								delete self._apiCallIsDeferred;
								self.onApiCallFinish();
								reject(err);
							}
						);
				});
			};
		}

		onApiCallStart() {
			let container = this.container;
			if (container) {
				container.classList.add('cm-loading');
			}
		}

		onApiCallFinish() {
			let container = this.container;
			if (container) {
				container.classList.remove('cm-loading');
			}
		}

		health(options, callback) {
			options = Object.assign({}, this.options, options);
			if (options.healthFields) {
				health(options.healthFields, callback);
			}
		}

		load(options) {
			let self = this;
			return Promise.resolve()
				.then(function () {
					return self.apiCall(options);
				})
				.then(function (response) {
					options = Object.assign({data: response}, options);
					return self.render(options);
				})
				.then(
					function (options) {
						self.emit('cm:load');
						return options;
					},
					function (err) {
						console.error(err);
						self.emit('cm:error', err);
						throw err;
					}
				);
		}

		reload(options) {
			let self = this;
			return Promise.resolve()
				.then(function () {
					return self.apiCall(options);
				})
				.then(function (response) {
					options = Object.assign({data: response}, options);
					return self.update(options);
				})
				.then(
					function (options) {
						self.emit('cm:load');
						return options;
					},
					function (err) {
						console.error(err);
						self.emit('cm:error', err);
						throw err;
					}
				);
		}
	};
}

const APIController = APIControllerMixin(Controller);
APIController.mixin = APIControllerMixin;

module.exports = APIController;